import styles from "./PropertyContent.module.scss"
import { PropertyContentProps } from "./PropertyContent.types"

export default function PropertyContent(props: PropertyContentProps) {
    const { children } = props

    return <div className={styles.base}>{children}</div>
}
